import "./Listing";
import "./Show";
import "./ShowEmpty";
import "./ShowEmptyEmpForDate";
import "select2";
import WorkDayEmbedForm from "./modals/WorkDayEmbedForm";
import WorkDayModalForm from "./modals/WorkDayModalForm";
import MexportModalForm from "./modals/MexportModalForm";
import ExportExclusionsPanel from "./modals/ExportExclusionsPanel";
import MassWorkDaysModalForm from "./modals/MassWorkDaysModalForm";
import WorkDaysHistoryModal from "./modals/WorkDaysHistoryModal";
import GridColumnsForm from "./modals/GridColumnsForm";
import BatchLockConfirmDialog from "./modals/BatchLockConfirmDialog";
import ShiftPlanModalForm from "../shift-plan/modals/ShiftPlanModalForm";
import ShiftPlanEmbedForm from "../shift-plan/modals/ShiftPlanEmbedForm";

import AttendanceCalendar from "./show/AttendanceCalendar";
import BulkActionBar from "./show/BulkActionBar";
import BatchImpactSummary from "./show/BatchImpactSummary";
import AttendanceStatistics from "./show/AttendanceStatistics";
import Deposits from "./show/Deposits";
import ExtraShifts from "./show/ExtraShifts";
import PersonalBonuses from "./show/PersonalBonuses";
import VariableWages from "./show/VariableWages";
import Holidays from "./show/Holidays";
import Balances from "./show/Balances";
import DynamicAddition from "./show/DynamicAddition";

Vue.component('work-day-embed-form', WorkDayEmbedForm);
Vue.component('work-day-modal-form', WorkDayModalForm);
Vue.component('mexport-modal-form', MexportModalForm);
Vue.component('export-exclusions-panel', ExportExclusionsPanel);
Vue.component('mass-work-days-modal-form', MassWorkDaysModalForm);
Vue.component('work-days-history-modal', WorkDaysHistoryModal);
Vue.component('shift-plan-modal-form', ShiftPlanModalForm);
Vue.component('shift-plan-embed-form', ShiftPlanEmbedForm);
Vue.component('attendance-calendar', AttendanceCalendar);
Vue.component('bulk-action-bar', BulkActionBar);
Vue.component('batch-impact-summary', BatchImpactSummary);
Vue.component('attendance-statistics', AttendanceStatistics);
Vue.component('deposits', Deposits);
Vue.component('extra-shifts', ExtraShifts);
Vue.component('personal-bonuses', PersonalBonuses);
Vue.component('variable-wages', VariableWages);
Vue.component('holidays', Holidays);
Vue.component('balances', Balances);
Vue.component('dynamic-addition', DynamicAddition);
Vue.component('attendance-grid-columns-form', GridColumnsForm);
Vue.component('batch-lock-confirm-dialog', BatchLockConfirmDialog);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/index.js